import { asMenuItem, MenuItem } from "../../components/menu";
import "./recurring.css";

const ICON = { ios: "f7:repeat", md: "material:repeat" };

const RecurringButton = asMenuItem(({ onClick }) => (
  <MenuItem
    className="recurring-entry"
    title="Wiederkehrende Ausgaben"
    icon={ICON}
    tone="indigo"
    onClick={onClick}
  />
));

export default RecurringButton;
